import { useState } from 'react';
import { API_BASE_URL } from '../config/config';
import {
  ApiResponse_calculatePayFastFeeResponseDTO,
  CalculatePayFastFeeRequestDTO,
  PayFastClient,
} from '../services/apiClient';
import axiosInstance from '../services/axiosInstance';
import { handleHookError } from '../utils/hookUtils/handleHookError';

interface UsePayFastApi {
  calculateFee: (
    amount: number,
  ) => Promise<ApiResponse_calculatePayFastFeeResponseDTO>;
  isLoading: boolean;
  error: string | null;
}

export const usePayFastApi = (): UsePayFastApi => {
  const apiClient = new PayFastClient(API_BASE_URL, axiosInstance);

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const calculateFee = async (
    amount: number,
  ): Promise<ApiResponse_calculatePayFastFeeResponseDTO> => {
    setIsLoading(true);
    try {
      const request: CalculatePayFastFeeRequestDTO = { amount };
      return await apiClient.calculatePayFastFee(request);
    } catch (err: unknown) {
      handleHookError(err, 'Error calculating PayFast fee', setError);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return { calculateFee, isLoading, error };
};
